import { SessionEvent } from '@trace/types';

const MIN = 10;
const MAX = 40;

const names = [
  'Button Click',
  'Crash',
  'Shook device in anger',
  'Turned off bluetooth',
  'Microphone level exceeded',
  'Turned volume up',
  'Turned volume down',
  'Double pressed home button',
  'Added to basket',
];

const getMockEvents = (start: number, end: number): SessionEvent[] =>
  Array.from({ length: Math.floor(MIN + Math.random() * (MAX - MIN)) }).map(() => ({
    timestamp: Math.floor(start + Math.random() * (end - start)),
    name: names[Math.floor(Math.random() * names.length)],
    id: (Math.random() * 1e18).toString(),
  }));

export default getMockEvents;
